<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class">
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="sumItem.type!='array' || !sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span v-if="formData[sumItem.field] == oldForm[sumItem.field]">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </span>
            <span
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ showCompare(sumItem, oldForm[sumItem.field]) }}
              </span>
              <span class="color-success">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class">
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span
              v-if="sumItem.type == 'value'&&!sumItem.option"
              v-copy="sumItem.value">
              {{ sumItem.value }}
            </span>
            <!--            <span-->
            <!--              v-else-if="sumItem.type == 'value'&&sumItem.option"-->
            <!--              v-copy="getName(sumItem.value)">-->
            <!--              {{ getName(sumItem.value) }}-->
            <!--            </span>-->
            <span
              v-else-if="sumItem.type == 'file'"
              class="blue pointer"
              @click="openFile(sumItem.value.url)">
              {{ getClientName(sumItem.value) }}
              <!--              {{ sumItem.value.client_name }}-->
            </span>
            <span
              v-else-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.name">{{sum.name}}<br></span>
            </span>
            <span
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              <span  v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
              <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="isFamily"
      class="box">
      <h2>Insurer Details</h2>
      <div
        v-for="(item,index) in nm_pa_list"
        :key="index"
        class="table">
        <div class="tr th">
          <span>Insured {{index+1}}</span>
        </div>
        <div class="tr">
          <span>Relationship</span>
          <span
            v-copy="getAllOptionName27('relation',item.rel_id)"
            :class="{'green-tip':compareChange(index,'rel_id')}">{{ getAllOptionName27('relation',item.rel_id) }}</span>
        </div>
        <div class="tr">
          <span>Title</span>
          <!--          <span  :class="{'green-tip':compareChange(index,'title')}">{{ getOptionName('titleOptions', item.title) }}</span>-->
          <span
            v-if="!compareChange(index,'title')"
            v-copy="getOptionName('titleOptions', item.title)"
          >
            {{ getOptionName('titleOptions', item.title) }}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getOptionName('titleOptions', oldTravle(index,'title')) }}
            </span>

            <span
              class="color-success">
              {{ getOptionName('titleOptions', item.title)}}
            </span >
          </span>

        </div>
        <div class="tr">
          <span>Last Name</span>
          <!--          <span :class="{'green-tip':compareChange(index,'lst_nm')}">{{ item.lst_nm }}</span>-->
          <span
            v-if="!compareChange(index,'lst_nm')"
            v-copy="item.lst_nm"
          >
            {{ item.lst_nm}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'lst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.lst_nm}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <!--          <span :class="{'green-tip':compareChange(index,'fst_nm')}">{{ item.fst_nm }}</span>-->
          <span
            v-if="!compareChange(index,'fst_nm')"
            v-copy="item.fst_nm"
          >
            {{ item.fst_nm}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'fst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.fst_nm}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>{{item.id_type==1?'HKID':'Passport'}}</span>
          <!--          <span  :class="{'green-tip':compareChange(index,'id_no')}">{{ item.id_no }}</span>-->
          <span
            v-if="!compareChange(index,'id_no')"
            v-copy="item.id_no"
          >
            {{ item.id_no}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'id_no') }}
            </span>

            <span
              class="color-success">
              {{ item.id_no}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span
            v-if="!compareChange(index,'dob')"
            v-copy="showHKDate(item.dob)"
          >
            {{ showHKDate(item.dob)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ showHKDate(oldTravle(index,'dob')) }}
            </span>

            <span
              class="color-success">
              {{ showHKDate(item.dob)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Occupation</span>
          <span
            v-if="!compareChange(index,'occ_id')"
          >
            {{ getAllOptionName27(item.age_type==2?'child_occupation':'occupation',item.occ_id)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getAllOptionName27(item.age_type==2?'child_occupation':'occupation',oldTravle(index,'occ_id')) }}
            </span>

            <span
              class="color-success">
              {{ getAllOptionName27(item.age_type==2?'child_occupation':'occupation',item.occ_id)}}
            </span >
          </span>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import dayjs from 'dayjs'

export default {
  name: 'PersonalQuoteInfo',
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote:{
      type: Boolean,
      default: false
    },
  },
  computed: {
    isFamily(){
      let {type_of_insured} = this.formData||{}
      return type_of_insured==2
    },
    oldTravle(){
      return (index,name)=>{
        let pre = this.oldForm||{}
        let preList =pre.nm_pa_list||[]
        if(preList.length<=0)return {}
        return preList[index][name]
      }
    },
    compareChange(){
      return (index,name)=>{
        let {type} = this.form||{}
        let list = this.nm_pa_list||[]
        let pre = this.oldForm||{}
        let preList =pre.nm_pa_list||[]
        // if(type!=50)return  false
        if(!this.isEndorsement)return  false
        if(preList.length<=0)return false
        return list[index][name]!=preList[index][name]||false
      }
    },
    nm_pa_list(){
      let {nm_pa_list=[]} = this.formData||{}
      return nm_pa_list
    },
    isShowEmployer(){
      let {occ_id} = this.formData||{}
      return ![220,246].includes(occ_id)
    },
    compareData() {
      let {quote_coverage_list={},class_id} = this.formData||{}
      const {benefits} = this.allOptions27||{}
      let benefitsList =benefits|| []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          let {benefits=[]} = this.formData||{}
          return benefits.includes(item.id)
        })
      }
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date',
                field: 'pcy_cmnt_date',
                type:'value',
                value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
              },
              {
                name: 'Expected Expiry Date',
                field: 'pcy_expry_date',
                // option:10
              },
              {
                name: 'Optional Benefits',
                field: 'benefits',
                type:'array',
                value:arr
              },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },
        {
          title: 'Policyholder Detail',
          isCompare: false,
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
            {
              name: 'Occupation',
              field: 'occ_id',
              fieldCode: 'occupation',
              option:27,
            },
            {
              name: 'Name of Employer',
              field: 'employer_nm',
              notShow:!this.isShowEmployer
            },
            {
              name: 'Nature of Business',
              field: 'employer_bsns_nature_id',
              fieldCode: 'industry',
              option:27,
              notShow:!this.isShowEmployer
            },
            {
              name: 'Handedness',
              field: 'handedness_id',
              option:27,
              fieldCode:'handedness'
            },
          ],
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        // {
        //   title: 'Upload Document',
        //   isCompare: false,
        //   isBold: true,
        //   list: [
        //     {
        //       name: 'Policyholder HKID',
        //       field: '',
        //
        //     }
        //   ],
        // },
      ]
      let officeList = {
        title: 'Office Address',
        isBold: false,
        list: [
          {
            name: 'Room',
            field: 'office_addr_room'
          }, {
            name: 'Floor',
            field: 'office_addr_floor'
          }, {
            name: 'Block',
            field: 'office_addr_block'
          }, {
            name: 'Building / Estate',
            field: 'office_addr_building'
          }, {
            name: 'Street',
            field: 'office_addr_street'
          }, {
            name: 'District',
            field: 'office_addr_district',
            addressCode: 'district',
            isAddress: true
          }, {
            name: 'Area',
            field: 'office_addr_area',
            addressCode: 'area',
            isAddress: true
          }, {
            name: 'Country / Region',
            field: 'office_addr_region',
            isAddress: true,
            addressCode: 'region'
          },
        ]
      }
      if(this.isShowEmployer)
        list.push(officeList)
      return list
    },
  },
  methods:{
    getClientName(data){
      let {client_name=''} = data||''
      return client_name
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            let {pcy_cmnt_dt=''} = this.formData||{}
            change=pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
            break
          case 27:
            change = this.getAllOptionName27(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      return change
    },
  }
}
</script>
<style lang="scss" scoped>
  .quote-info {
    .box {
      margin-bottom: 15px;
    }
    .mg-b-0 {
      margin-bottom: 0!important;
    }

    .title {
      display: block;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 400;
      color: #616266;
    }

    .table {
      .tr {
        .compare {
          display: flex;
          align-items: center;

          & > span {
            flex: 1;
          }
        }
      }
    }
    .asap{
      font-weight: bold;
      color: black;
      margin-left: 5px;
    }
  }
</style>
